import axios from 'axios'
import { AppConfig } from '@/config.js'
import { saveAs } from 'file-saver'

axios.defaults.baseURL = AppConfig.ApiBaseUrl
axios.defaults.headers['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers['Access-Control-Allow-Headers'] = 'Origin, X-Auth-Token, X-Requested-With, Authorization, Content-Type, Accept'
axios.defaults.headers['Access-Control-Allow-Methods'] = 'HEAD, POST, GET, PUT, PATCH, DELETE, OPTIONS'

const appService = {

  // axios
  axiosGet (url) {
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },

  axiosPost (url, body) {
    return new Promise((resolve, reject) => {
      axios.post(url, body).then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },

  axiosPut (url, body) {
    return new Promise((resolve, reject) => {
      axios.put(url, body).then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },

  axiosDelete (url) {
    return new Promise((resolve, reject) => {
      axios.delete(url).then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(error)
      })
    })
  },

  // admin
  getAdminApiAssemblyVersion () {
    return this.axiosGet('admin/build/version')
  },

  getAdminSummaryOrganization () {
    return this.axiosGet('admin/summary/organization')
  },

  getAdminSummaryDomain () {
    return this.axiosGet('admin/summary/domain')
  },

  getAdminSummaryFacility () {
    return this.axiosGet('admin/summary/facility')
  },

  getAdminSummaryKiosk () {
    return this.axiosGet('admin/summary/kiosk')
  },

  getAdminSummaryResident () {
    return this.axiosGet('admin/summary/resident')
  },

  getAdminSummaryUser () {
    return this.axiosGet('admin/summary/user')
  },

  getForAdminLogin (profile) {
    return this.axiosPost('admin/login', profile)
  },

  getMessagePurges () {
    return this.axiosGet('admin/message-purges')
  },

  getMessagePurgeDetails (messagePurgeId) {
    return this.axiosGet(`admin/message-purge-details/purge/${messagePurgeId}`)
  },

  getAbbyUpdateZips () {
    return this.axiosGet('abbyupdates')
  },

  deleteAbbyUpdateZip (version, level) {
    return this.axiosDelete(`abbyupdates/version/${version}/level/${level}`)
  },

  // events

  getUserEvents () {
    return this.axiosGet('admin/user-events')
  },

  getResidentEvents () {
    return this.axiosGet('admin/resident-events')
  },

  getKioskEvents () {
    return this.axiosGet('admin/kiosk-events')
  },

  getAbbyKioskPlaylistEvents () {
    return this.axiosGet('admin/abby-playlist-events')
  },

  getAbbyResidentPlaylistEvents () {
    return this.axiosGet('admin/abby-playlist-events?isKiosk=false')
  },

  getGenieKioskPlaylistEvents () {
    return this.axiosGet('admin/genie-playlist-events')
  },

  getGenieResidentPlaylistEvents () {
    return this.axiosGet('admin/genie-playlist-events?isKiosk=false')
  },

  // stats
  getStatTypes () {
    return this.axiosGet(`stats/types`)
  },

  // getStatsByFacility (facilityId, typeId, filename, contentType) {
  //   return new Promise((resolve, reject) => {
  //     axios({
  //       url: `stats/facility/${facilityId}/type/${typeId}`,
  //       method: 'get',
  //       headers: { 'Accept': `${contentType}` },
  //       responseType: 'blob'
  //     }).then((response) => {
  //       const blob = new Blob([response.data])
  //       saveAs(blob, filename + `${contentType === "application/zip" ? '.zip' : '' }`)
  //       resolve()
  //     })
  //     .catch(error => {
  //       reject(error)
  //     })
  //   })
  // },
  
  // organizations
  getOrganizationsForManager () {
    return this.axiosGet(`organizations/manager`)
  },

  addOrganization(organization) {
    return this.axiosPost(`organizations`, organization)
  },

  updateOrganization(id, organization) {
    return this.axiosPut(`organizations/${id}`, organization)
  },

  deleteOrganization(id) {
    return this.axiosDelete(`organizations/${id}`)
  },

  // domains
  getDomainsForManager () {
    return this.axiosGet(`domains/manager`)
  },

  getDomain (id) {
    return this.axiosGet(`domains/${id}`)
  },

  addDomain (domain) {
    return this.axiosPost(`domains`, domain)
  },

  updateDomain (id, domain) {
    return this.axiosPut(`domains/${id}`, domain)
  },

  deleteDomain (id) {
    return this.axiosDelete(`domains/${id}`)
  },

  getOrganizationDomains(id) {
      return this.axiosGet(`domains/organization/${id}`)
  },

  getWorkbook (filename) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'workbook',
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel' },
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data])
        saveAs(blob, filename + '.xlsx')
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // facilities
  getFacilities (ids) {
    if (ids === null || ids === undefined) {
      return this.axiosGet(`facilities`)
    } else {
      return this.axiosPost(`facilities`, ids)
    }
  },

  getFacility (id) {
    return this.axiosGet(`facilities/${id}`)
  },

  getFacilitiesForManager () {
    return this.axiosGet(`facilities/manager`)
  },

  getFacilitiesByDomain (id) {
    return this.axiosGet(`facilities/domain/${id}`)
  },

  getFacilitiesByOrganization (id) {
    return this.axiosGet(`facilities/organization/${id}`)
  },

  addFacility (facility) {
    return this.axiosPost(`facilities`, facility)
  },

  updateFacility (id, facility) {
    return this.axiosPut(`facilities/${id}`, facility)
  },

  deleteFacility (id) {
    return this.axiosDelete(`facilities/${id}`)
  },

  // kiosks
  getKiosksForManager () {
    return this.axiosGet('kiosks/manager')
  },

  getKiosks (typeId) {
    const url = typeId !== null && typeId !== undefined
      ? `kiosks/type/${typeId}`
      : 'kiosks'
    return this.axiosGet(url)
  },

  getKiosk (id) {
    return this.axiosGet(`kiosks/${id}`)
  },

  addKiosk (kiosk) {
    //const json = JSON.stringify(kiosk)
    return this.axiosPost(`kiosks`, kiosk)
  },

  updateKiosk (id, kiosk, baseOnly, locale) {
    if (baseOnly === null || baseOnly === undefined) baseOnly = false
  
    var url = baseOnly
      ? `kiosks/${id}?baseOnly=true`
      : `kiosks/${id}`

    if (locale !== undefined) {
      url = baseOnly
        ? `${url}&locale=${locale}`
        : `${url}?locale=${locale}`
    }

    return this.axiosPut(url, kiosk)
  },

  deleteKiosk (id, updateByUserId) {
    const baseUrl = `kiosks/${id}`
    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosDelete(url)
  },

  getKiosksForLogin (profile) {
    return this.axiosPost(`kiosks/login`, profile)
  },

  getFacilityKiosks (id) {
    return this.axiosGet(`kiosks/facility/${id}`)
  },

  getKioskComboboxOptions (kioskTypeId) {
    const url = kioskTypeId !== undefined
      ? `kiosks/combo-options?kioskTypeId=${kioskTypeId}`
      : 'kiosks/combo-options'

    return this.axiosGet(url)
  },

  getKioskExtended (id) {
    return this.axiosGet(`kiosks/${id}/extended`)
  },

  // kiosk key tags
  getKioskKeyTags(kioskId) {
    return this.axiosGet(`kiosks/keytags/${kioskId}`)
  },
  
  getKioskKeyTagsForMapper() {
    return this.axiosGet(`kiosks/keytags/mapper`)
  },

  addKioskKeyTag(keyTag) {
    return this.axiosPost(`kiosks/keytags`, keyTag)
  },

  updateKioskKeyTag(id, keyTag) {
    return this.axiosPut(`kiosks/keytags/${id}`, keyTag)
  },

  deleteKioskKeyTag(id) {
     return this.axiosDelete(`kiosks/keytags/${id}`)
  },

  // temporary (for tammy)
  getUnupdatedAbbys () {
    return this.axiosGet(`kiosks/unupdated-abbys`)
  },

  // temporary (for daniel)
  getUpdateOverrideAbbys () {
    return this.axiosGet(`kiosks/update-override-abbys`)
  },

  // temporary (for daniel)
  activateUpdateOverrideAbbys (ids) {
    if (ids !== null && ids !== undefined)
    return this.axiosPost(`kiosks/activate-override-abbys`, ids)
  },

  // kiosk dashboard
  getKioskDashboardGeneralStats (id) {
    return this.axiosGet(`kioskdashboard/${id}/stats`)
  },

  getKioskDashboardManagerStats (id, userId) {
    return this.axiosGet(`kioskdashboard/${id}/manager-stats?userId=${userId}`)
  },

  getKioskDashboardResidentSummaries (id) {
    return this.axiosGet(`kioskdashboard/${id}/resident-summaries`)
  },

  getKioskEmails (id) {
    return this.axiosGet(`kioskemails/kiosk/${id}`)
  },

  // residents
  getResidentsForLogin (profile) {
    return this.axiosPost(`residents/login`, profile)
  },

  getResidentsForLoginByKiosk (profile, kioskId) {
    return this.axiosPost(`residents/login/kiosk/${kioskId}`, profile)
  },

  getKioskResidents (id) {
    return this.axiosGet(`residents/kiosk/${id}`)
  },

  getResidentsForManager () {
    return this.axiosGet('residents/manager')
  },

  getResident (id) {
    return this.axiosGet(`residents/${id}`)
  },

  getResidentExtended (id) {
    return this.axiosGet(`residents/${id}/extended`)
  },

  getResidentListWithPicture (profile, kioskTypeId) {
    const url = kioskTypeId !== undefined
      ? `residents/profile/picture?kioskTypeId=${kioskTypeId}&includeAll=true`
      : 'residents/profile/picture?includeAll=true'
      
    return this.axiosPost(url, profile)
  },

  addResident (resident, locale) {
    const url = locale !== undefined
      ? `residents?locale=${locale}`
      : 'residents'

    return this.axiosPost(url, resident)
  },

  updateResident (id, resident, baseOnly, locale) {
    //var json = JSON.stringify(resident)

    if (baseOnly === undefined) baseOnly = false

    const rootUrl = `residents/${id}`
    const url = locale === undefined
      ? baseOnly
        ? `${rootUrl}?baseOnly=true`
        : rootUrl
      : baseOnly
        ? `${rootUrl}?baseOnly=true&locale=${locale}`
        : `${rootUrl}?locale=${locale}`

    return this.axiosPut(url, resident)
  },

  deleteResident (id, updateByUserId) {
    const baseUrl = `residents/${id}`
    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosDelete(url)
  },

  assignResidentKioskKeyTag (id, keyTagId, updateByUserId, locale) {
    const baseUrl = `residents/${id}/tag/${keyTagId}`
    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}&locale=${locale}`
      : baseUrl

    return this.axiosGet(url)
  },

  getResidentPicture (id) {
    return this.axiosGet(`residents/${id}/picture/base64`)
  },

  getResidentPictures () {
    return this.axiosGet(`residents/pictures/base64`)
  },

  getResidentPicturesByIds (ids) {
    return this.axiosPost(`residents/pictures/base64`, ids)
  },

  // resident dashboard
  getResidentDashboardUsers (id) {
    return this.axiosGet(`residentdashboard/${id}/users`)
  },

  getResidentDashboardBarChart (dataSource, id, chartOptions, locale) {
    //var json = JSON.stringify(chartOptions)

    const url = locale === undefined
      ? `residentdashboard/${id}/${dataSource}`
      : `residentdashboard/${id}/${dataSource}?locale=${locale}`
    
    return this.axiosPost(url, chartOptions)
  },

  getResidentDashboardMessagesChartData (id, timePeriod, locale) {
    const url = locale === undefined
      ? `residentdashboard/${id}/message`
      : `residentdashboard/${id}/message?timePeriod=${timePeriod}&locale=${locale}`

    return this.axiosGet(url)
  },

  getResidentDashboardPlaylists (id) {
    return this.axiosGet(`residentdashboard/${id}/playlist`)
  },

  getResidentDashboardSummary (id) {
    return this.axiosGet(`residentdashboard/${id}/summary`)
  },

  // resident playlists
  getAllResidentPlaylists () {
    return this.axiosGet(`residentplaylists`)
  },

  getResidentPlaylist (id) {
    return this.axiosGet(`residentplaylists/${id}`)
  },

  addResidentPlaylist (playlist) {
    return this.axiosPost(`residentplaylists`, playlist)
  },

  updateResidentPlaylist (id, playlist) {
    return this.axiosPut(`residentplaylists/${id}`, playlist)
  },

  deleteResidentPlaylist (id, updateByUserId) {
    const baseUrl = `residentplaylists/${id}`
    
    const url = updateByUserId !== undefined
    ? `${baseUrl}?updateByUserId=${updateByUserId}`
    : baseUrl

    return this.axiosDelete(url)
  },

  addPlaylistBlobs (playlistBlobs, isKiosk) {
    //var json = JSON.stringify(playlistBlobs)

    const url = !isKiosk
      ? 'residentplaylistblobs'
      : 'kioskplaylistblobs'

    return this.axiosPost(`${url}/bulk`, playlistBlobs)
  },

  deletePlaylistBlob (id, isKiosk, updateByUserId) {
    const baseUrl = !isKiosk
      ? `residentplaylistblobs/${id}`
      : `kioskplaylistblobs/${id}`

    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl
    
    return this.axiosDelete(url)
  },

  deletePlaylistBlobsBulk (ids, updateByUserId) {
    const baseUrl = 'residentplaylistblobs/delete'

    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl
    
    return this.axiosPost(url, ids)
  },

  getResidentPlaylists (residentId) {
    return this.axiosGet(`residentplaylists/resident/${residentId}`)
  },

  updateResidentPlaylistCoverImage (id, mediaItemId) {
    return this.axiosPut(`residentplaylists/${id}/cover-media/${mediaItemId}`)
  },

  // kiosk playlists
  getAllKioskPlaylists () {
    return this.axiosGet(`kioskplaylists`)
  },

  getKioskPlaylist (id) {
    return this.axiosGet(`kioskplaylists/${id}`)
  },

  addKioskPlaylist (playlist) {
    return this.axiosPost(`kioskplaylists`, playlist)
  },

  updateKioskPlaylist (id, playlist) {
    return this.axiosPut(`kioskplaylists/${id}`, playlist)
  },

  deleteKioskPlaylist (id, updateByUserId) {
    const baseUrl = `kioskplaylists/${id}`

    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosDelete(url)
  },

  deleteKioskPlaylistBlob (id, updateByUserId) {
    const baseUrl = `kioskplaylistblobs/${id}`

    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosDelete(url)
  },

  deleteKioskPlaylistBlobsBulk (ids, updateByUserId) {
    const baseUrl = 'kioskplaylistblobs/delete'

    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl
      
    return this.axiosPost(url, ids)
  },

  getKioskAmbientPlaylist (id) {
    return this.axiosGet(`kioskplaylists/${id}/ambient`)
  },

  getKioskPlaylists (kioskId) {
    return this.axiosGet(`kioskplaylists/kiosk/${kioskId}`)
  },

  getMediaItems (containerName, playlistId, isKiosk, mediaType, includeSystem) {
    var url = null

    if (playlistId !== null) {
      // only media available to playlists
      url = !isKiosk
        ? `mediaitems/${containerName}/playlist/${playlistId}`
        : `mediaitems/${containerName}/kioskplaylist/${playlistId}`
    } else {
      // all media
      url = `mediaitems/${containerName}`

      var separator = '?'
      if (mediaType !== null) {
        url = `${url}?mediaType=${mediaType}`
        separator = '&'
      }
      if (includeSystem !== null && includeSystem !== undefined) {
        url = `${url}${separator}includeSystem=${includeSystem}`
      }
    }

    return this.axiosGet(url)
  },

  updateMediaItem (properties, containerName) {
    return this.axiosPut(`mediaitems/${containerName}/update`, properties)
  },

  deleteMediaItem (containerName, blobName) {
    return this.axiosDelete(`mediaitems/${containerName}?blobName=${blobName}`)
  },

  deleteMediaItemsBulk (ids) {
    return this.axiosPost(`mediaitems/delete`, ids)
  },

  getBlobUrl (containerName, blobName) {
    return this.axiosPost(`mediaitems/${containerName}`, { BlobName: blobName })
  },

  getAbbyMediaPathTypes (isSystem, isSharable, languageId) {
    const baseUrl = 'mediapathtypes'
    var systemQuery = ''
    var sharableQuery = ''
    var languageQuery = ''
    var queryString = ''

    if (isSystem !== undefined) {
      systemQuery = isSystem ? 'isSystem=true' : 'isSystem=false'
    }
    if (isSharable !== undefined) {
      sharableQuery = isSharable ? 'isSharable=true' : 'isSharable=false'
    }
    if (languageId !== undefined) {
      languageQuery = `languageId=${languageId}`
    }
    if (systemQuery.length > 0 && sharableQuery.length > 0) {
      queryString = `?${systemQuery}&${sharableQuery}`
    } else if (systemQuery.length > 0) {
      queryString = `?${systemQuery}`
    } else if (sharableQuery.length > 0) {
      queryString = `?${sharableQuery}`
    }

    if (languageQuery.length > 0) {
      queryString += `&${languageQuery}`
    }

    return this.axiosGet(`${baseUrl}${queryString}`)
  },

  getAbbyMediaByContainer (containerId, profileId, mediaPathTypeId, forResident) {
    const isPicker = profileId !== null && mediaPathTypeId !== null
    const isResident = forResident !== undefined ? (forResident ? 'true' : 'false') : 'false'

    const url = isPicker
      ? `mediafiles/available/profile/${profileId}/pathtype/${mediaPathTypeId}?isResident=${isResident}`
      : `mediafiles/container/${containerId}`

    return this.axiosGet(url)
  },

  getAbbyMediaById (id) {
    return this.axiosGet(`mediafiles/${id}`)
  },

  getAbbyBlobUrl (containerName, blobName) {
    return this.axiosPost(`mediafiles/${containerName}`, { blobName: blobName })
  },

  deleteAbbyMediaFilesBulk (ids) {
    return this.axiosPost('mediafiles/delete', ids)
  },

  updateAbbyMediaFile (id, mediaFile) {
    return this.axiosPut(`mediafiles/${id}`, mediaFile)
  },

  getAbbyResidentProfiles (residentId, locale) {
    const baseUrl = `abbyresidentprofiles/resident/${residentId}`
    const url = locale !== undefined
      ? `${baseUrl}?locale=${locale}`
      : baseUrl

    return this.axiosGet(url)
  },

  getAbbyKioskProfiles (kioskId, locale) {
    const baseUrl = `abbykioskprofiles/kiosk/${kioskId}`
    const url = locale !== undefined
      ? `${baseUrl}?locale=${locale}`
      : baseUrl

    return this.axiosGet(url)
  },

  getAbbyKioskProfileStatuses (kioskId) {
    return this.axiosGet(`abbykioskprofiles/kiosk/${kioskId}/statuses`)
  },

  getAbbyKioskProfileStatus (id) {
    return this.axiosGet(`abbykioskprofiles/${id}/status`)
  },

  addAbbyProfile (abbyProfile, isResident) {
    const url = isResident
      ? 'abbyresidentprofiles'
      : 'abbykioskprofiles'

    return this.axiosPost(url, abbyProfile)
  },

  updateAbbyProfile (id, abbyProfile, isResident) {
    const url = isResident
      ? 'abbyresidentprofiles'
      : 'abbykioskprofiles'

    return this.axiosPut(`${url}/${id}`, abbyProfile)
  },

  deleteAbbyProfile (id, isResident, updateByUserId) {
    const baseUrl = isResident
      ? `abbyresidentprofiles/${id}`
      : `abbykioskprofiles/${id}`

    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosDelete(url)
  },

  // abby profile details
  addProfileDetails (details, isResident) {
    // const json = JSON.stringify(details)
    
    const baseUrl = 'abbyprofiledetails/bulk'
    const url = isResident
      ? `${baseUrl}?isResident=true`
      : baseUrl

    return this.axiosPost(url, details)
  },

  deleteProfileDetails (ids, isResident, updateByUserId) {
    const baseUrl = isResident
      ? 'abbyprofiledetails/delete?isResident=true'
      : 'abbyprofiledetails/delete'

    const url = updateByUserId !== undefined
      ? isResident 
        ? `${baseUrl}&updateByUserId=${updateByUserId}`
        : `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosPost(url, ids)
  },

  // users
  getUsersForManager (profile) {
    //const json = JSON.stringify(profile)
    return this.axiosPost('users/manager', profile)
  },

  getUsersExtraFields (ids, isAdmin) {
    //const json = JSON.stringify(profile)
    const isAdminSafe = isAdmin !== undefined
      ? isAdmin
      : false
    return this.axiosPost(`users/manager/extra-fields?isAdmin=${isAdminSafe}`, ids)
  },

  sendChangePasswordEmail (email) {
    return this.axiosPost(`users/change-password-email`, { email: email })
  },

  getKioskManagers (id) {
    return this.axiosGet(`users/kiosk/${id}/manager`)
  },

  // getKioskAdministrators (id) {
  //   return this.axiosGet(`users/facility/${id}/manager`)
  // },

  getDomainManagers (id) {
    return this.axiosGet(`users/domain/${id}/manager`)
  },

  getDomainManagersForOrganization (id) {
    return this.axiosGet(`users/organization/${id}/manager`)
  },

  createUserFromManager (user, locale) {
    const baseUrl = 'users'
    const url = locale !== undefined
      ? `${baseUrl}?locale=${locale}`
      : baseUrl

    return this.axiosPost(url, user)
  },

  createUserFromDashboard (user, target, locale) {
    const baseUrl = `users/dashboard/${target}`
    const url = locale !== undefined
      ? `${baseUrl}?locale=${locale}`
      : baseUrl

    return this.axiosPost(url, user)
  },

  updateUser (id, user, locale) {
    //const json = JSON.stringify(user)

    const baseUrl = `users/${id}`
    const url = locale !== undefined
      ? `${baseUrl}?locale=${locale}`
      : baseUrl

    return this.axiosPut(url, user)
  },

  deleteUser (id, updateByUserId) {
    const baseUrl = `users/${id}`
    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosDelete(url)
  },

  unlinkUser (model, locale) {
    const baseUrl = `users/unlink`
    const url = locale !== undefined
      ? `${baseUrl}?locale=${locale}`
      : baseUrl

    return this.axiosPost(url, model)
  },

  removeUserResident (residentId, updateByUserId) {
    const baseUrl = `users/remove/resident/${residentId}`
    const url = updateByUserId !== undefined
      ? `${baseUrl}?updateByUserId=${updateByUserId}`
      : baseUrl

    return this.axiosGet(url)
  },

  removeUserFacility (facilityId) {
    return this.axiosGet(`users/remove/facility/${facilityId}`)
  },

  unblockUser (id) {
    return this.axiosGet(`users/${id}/unblock`)
  },

  // messages
  getProfileMessages (profile, last) {
    const baseUrl = 'messages/profile'
    const url = last !== undefined
      ? `${baseUrl}?last=${last}`
      : baseUrl
      
    return this.axiosPost(url, profile)
  },

  createMessage (message) {
    return this.axiosPost('messages', message)
  },

  updateMessage (messageId, message) {
    return this.axiosPut(`messages/${messageId}`, message)
  },

  updateMessageThread (threadId, thread) {
    return this.axiosPut(`messages/thread/${threadId}`, thread)
  },

  deleteMessage (messageId) {
    return this.axiosDelete(`messages/${messageId}`)
  },

  logVoiceMessage (id) {
    return this.axiosGet(`messages/${id}/voiceurl?log=true`)
  },

  addMessageBlobs (messageBlobs) {
    return this.axiosPost(`messageblobs/bulk`, messageBlobs)
  },

  deleteMessageBlob (id) {
    return this.axiosDelete(`messageblobs/${id}`)
  },

  // configs / details (Genie only)
  getConfigs () {
    return this.axiosGet(`configs`)
  },

  getPhidgetInputs () {
    return this.axiosGet(`configs/phidgets/inputs`)
  },

  getPhidgetOutputs () {
    return this.axiosGet(`configs/phidgets/outputs`)
  },

  getPhidgetStyles () {
    return this.axiosGet(`configs/phidgetstyles`)
  },

  getPhidgetActions () {
    return this.axiosGet(`configs/phidgetactions`)
  },

  getButtonConfigsForManager () {
    return this.axiosGet(`buttonconfigs/manager`)
  },

  addButtonConfigDetail (configDetail) {
    return this.axiosPost(`buttonconfigdetails`, configDetail)
  },

  updateButtonConfigDetail (id, configDetail) {
    return this.axiosPut(`buttonconfigdetails/${id}`, configDetail)
  },

  deleteButtonConfigDetail (id) {
    return this.axiosDelete(`buttonconfigdetails/${id}`)
  },

  // user profile
  getForProfileEdit (profile) {
    return this.axiosPost(`users/profile-edit`, profile)
  },

  updateUserProfile (id, profile) {
    return this.axiosPut(`users/${id}/profile/admin`, profile)
  },

  updateUserPassword (id, password) {
    return this.axiosPut(`users/${id}/password`, password)
  },

  // abby activities
  getAbbyActivities () {
    return this.axiosGet(`abbyactivities`)
  },

  addAbbyActivity (activity) {
    return this.axiosPost(`abbyactivities`, activity)
  },

  updateAbbyActivity (id, activity) {
    return this.axiosPut(`abbyactivities/${id}`, activity)
  },

  getAbbyActivityUpdateZip (updateLevel, activities) {
    return new Promise((resolve, reject) => {
      axios({
        url: `abbyactivities/download/zip/${updateLevel}`,
        method: 'post',
        data: activities,
        headers: { 'Accept': 'application/zip' },
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([response.data])

        saveAs(blob, `${updateLevel}.zip`)
        resolve()
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  // abby ambient invitations
  getAbbyAmbientInvitations () {
    return this.axiosGet('ambientinvitations')
  },

  addAbbyAmbientInvitation (invitation) {
    return this.axiosPost(`ambientinvitations`, invitation)
  },

  updateAbbyAmbientInvitation (id, invitation) {
    return this.axiosPut(`ambientinvitations/${id}`, invitation)
  },

  deleteAbbyAmbientInvitations (id) {
    return this.axiosDelete(`ambientinvitations/${id}`)
  },

  // abby expressions
  getAbbyExpressions () {
    return this.axiosGet('expressions/manager')
  },

  updateAbbyExpressions (languageId, type, expressions) {
    return this.axiosPut(`expressions/language/${languageId}/${type}`, expressions)
  }
}

export default appService
